import { jsml } from "../jsml.js";
import { retrieveComparisonIds } from "../integrateFilterCompare.js";

export function methodDisplayNull(request, $url = '') {
     // Get current language
    const getCurrentLanguage = () => {
        return document.getElementById('current_language').dataset.language;
    }

    const language = getCurrentLanguage() || 'en';

    let renderHTML = '<div class="site-width"><h2 class="fs-40 ff-2 i-gold mt-200">' + jsml(language, 'There are no current events at The Reverie Saigon.') + '</h2></div>';




     // Structure new HTML value with DOM Parser (Adding the new elements created to the DOM);
     let html = new DOMParser().parseFromString(renderHTML, "text/html");
     html = html.getRootNode();
     document.getElementById("filter-results").innerHTML = '';
     document.getElementById("filter-results").append(html.body);

     // Add class (Which will tell the classWatcher event to fire) when the results are loaded
     document.getElementById('filter-results').classList.add('filter-results-loaded');



}